/** @format */

import open_in_new from '../assets/icons/open_in_new.svg';

export const OPEN_IN_NEW_ICON = open_in_new;

export const FILTER_MODE_CONTAINS = 0;
export const FILTER_MODE_STARTS_WITH = 1;
export const FILTER_MODE_ENDS_WITH = 2;
